import WidgetPanel from "./WidgetPanel";


export default WidgetPanel;